import React, { useMemo } from "react";
import { marked } from "marked";

marked.setOptions({
  gfm: true,
  breaks: true,
});

function parseMarkdown(markdown) {
  if (!markdown || typeof markdown !== "string") return "";
  const source = markdown.trim();
  if (!source) return "";

  try {
    const html = marked.parse(source, { async: false });
    return typeof html === "string" ? html : "";
  } catch {
    return "";
  }
}

export default function AcademyLessonContent({ markdown = "" }) {
  const html = useMemo(() => parseMarkdown(markdown), [markdown]);
  if (!html) return null;

  return (
    <div
      className="training-lesson-content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
